import { render, staticRenderFns } from "./LandingCta.vue?vue&type=template&id=499723b7&scoped=true&"
import script from "./LandingCta.vue?vue&type=script&lang=js&"
export * from "./LandingCta.vue?vue&type=script&lang=js&"
import style0 from "./LandingCta.vue?vue&type=style&index=0&id=499723b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499723b7",
  null
  
)

export default component.exports